// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"235":"a5b0ec17","900":"d261f383"}[chunkId] || chunkId) + "." + {"123":"0bf5d22cfc4c41e8","198":"ac73a243403c1428","235":"fa58ec668232f88a","557":"bee61e2129efc03d","574":"57ff80c252e6c7a2","900":"9f0e545960da6be0"}[chunkId] + ".js";
};